import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import 'tw-elements'

createInertiaApp({
    // resolve: name => import(`./Pages/${name}`),
    resolve: name => require(`./Pages/${name}`),
    title: title => title ? `${title} - YEU Logistik` : 'YEU Logistik',
    setup ({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .mount(el)
    },
})
